export const Path = {
  PAYMENTMODE: "/",
  PAYMENTDETAILS: "/payment-detail",
  TRANSACTION_FAILED: "/transaction-failed",
  REDIRECT_AFTER_PAYMENT: '/checkPaymentStatus',
  UNAUTHORIZED_INPUT: "/unauthorized",
  UNDER_MAINTENANCE: "/under-maintenance"
};
